import { createStyles, makeStyles } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const { DARK_SECONDARY_BUTTONBACKGROUND, LIGHT_MENUITEM_BACKGROUND } = COLORS;

export const useStyles = makeStyles((theme) =>
  createStyles({
    paper: {},
    dialogContent: {
      padding: '32px 64px',
    },
    titleContainer: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: theme.spacing(4),
    },
    buttonError: {
      border: `1px solid ${theme.palette.error.main} !important`,
    },

    buttonContainer: {
      marginTop: theme.spacing(6),
      display: 'flex',
      justifyContent: 'center',
    },

    dateInputRoot: {
      backgroundColor:
        theme.palette.type === 'dark'
          ? `${DARK_SECONDARY_BUTTONBACKGROUND} !important`
          : `${LIGHT_MENUITEM_BACKGROUND} !important`,
    },
  }),
);
